

const state = {
  assets: null,
  selectedAsset: null,
  updateAsset: null
}

const getters = {
  getAssets: (state) => state.assets,
  getSelectedAsset: (state) => state.selectedAsset,
  getUpdatedAsset: state => state.updatedAsset
}
const actions = {
  setSelectedAsset ({ commit }, { asset }) {
    commit('setSelectedAsset', { asset })
  },

  addAssetProcess ({ commit }, { asset }) {
    commit('addAssetProcess', { asset })
  },

  addImportedAssets ({ commit }, { assets }) {
    commit('addImportedAssets', { assets })
  },

  replaceAsset ({ commit }, { asset }) {
    commit('replaceAsset', { asset })
  },

  setAssets ({ commit }, { assets }) {
    commit('setAssets', { assets })
  },

  deleteAsset ({ commit }, { locationId }) {
    commit('deleteAsset', { locationId })
  },

  deleteAssetProcess ({ commit }, { record }) {
    commit('deleteAssetProcess', { record })
  }
}
const mutations = {
  setSelectedAsset (state, { asset }) {
    state.selectedAsset = asset
  },

  setAssets (state, { assets }) {
    state.assets = assets
  },

  addAssetProcess (state, { asset }) {
    state.assets.splice(0, 0, asset)
  },

  addImportedAssets (state, { assets }) {
    state.assets = [...state.assets, ...assets]
  },

  replaceAsset (state, { asset }) {
    const assetIndex = state.assets.findIndex(current => current.locationId === asset.locationId)
    if (assetIndex !== -1) {
      state.assets[assetIndex] = state.updatedAsset = asset
    }
  },

  deleteAsset (state, { locationId }) {
    const assetIndex = state.assets.findIndex(current => current.locationId === locationId)
    if (assetIndex !== -1) {
      state.assets.splice(assetIndex, 1)
    }
  },

  deleteAssetProcess (state, { record }) {
    const assetIndex = state.assets.findIndex(current => current.locationId === record.locationId?.full)
    if (assetIndex !== -1) {
      const processIndex = state.assets[assetIndex].processes.findIndex(process => process.processUuid === record.uuid)
      if (processIndex !== -1) {
        state.assets[assetIndex].processes.splice(processIndex, 1)
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
